import cloneDeep from 'clone-deep'

import {
  canContractorOriginHaveSection,
  ContractorFieldProps,
  ContractorOrigin,
  IContractorOriginSection,
} from './contractor.input.visibility.type'

/** Ensure section-capable origins have a sections array; seed with all inputs when missing. */
export const ensureContractorSections = (props: ContractorFieldProps): ContractorFieldProps => {
  const next = cloneDeep(props)
  Object.values(ContractorOrigin).forEach((origin) => {
    if (!canContractorOriginHaveSection(origin)) return
    if (!next[origin]) next[origin] = { inputs: {} }
    const inputs = next[origin].inputs ?? {}
    const inputKeys = Object.keys(inputs)

    if (!next[origin].sections?.length) {
      next[origin].sections = [
        {
          id: 1,
          title: 'Section 1',
          fields: [...inputKeys],
        },
      ]
      inputKeys.forEach((key) => {
        if (inputs[key]) inputs[key].section = '1'
      })
      return
    }

    next[origin].sections = next[origin].sections!.map((section) => ({
      ...section,
      fields: section.fields.filter((key) => inputKeys.includes(key)),
    }))
  })
  return next
}

export const getContractorSectionOptions = (
  sections: IContractorOriginSection[] | undefined,
): Record<string, string> => {
  const options: Record<string, string> = {}
  ;(sections || []).forEach((section) => {
    options[`${section.id}`] = section.title || `Section ${section.id}`
  })
  return options
}
